<template>
  <div class="">
    <navigation></navigation>
    <banner mainzh="集团介绍" mainen="INTRODUCE"></banner>
    <div class="main-con">
      <vmenu></vmenu>
      <vcontent></vcontent>
    </div>
    <vfooter></vfooter>
  </div>
</template>
<script>
import navigation from "@/components/sub/Nav";
import vfooter from "@/components/sub/Footer";
import banner from "@/components/sub/Banner";
import vmenu from "@/components/sub/Menu";
import vcontent from "@/components/sub/Content";
export default {
  name: "home",
  components: {
    navigation,
    vfooter,
    banner,
    vmenu,
    vcontent,
  },
  mounted(){
    // console.log(this.$refs.banner);
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/Home.vue